import React from "react";
import ModalWrapper from "../../../../../components/ModalWrapper";

const RlcsClassificationMapModal: React.FC<{
  show: boolean;
  setShow: () => void;
}> = ({ show, setShow }) => {
  const imgRlcsClassificationMapping = `${window.tcbase.urls.static}images/rlcs-classification-mapping.png`;

  return (
    <ModalWrapper
      id="rlcs_classification_mapping"
      title="Methodology / Legend (RL Cloud Sandbox Classification and Risk Score Mapping)"
      show={show}
      size="lg"
      onHide={setShow}
    >
      <p>
        ReversingLabs Cloud Sandbox's Risk Score indicates how malicious a
        particular sample is, providing users with additional insights into the
        dynamic analysis results and the ability to fine-tune their detection
        thresholds.
      </p>

      <img
        src={imgRlcsClassificationMapping}
        className="mw-100"
        alt="Methodology / Legend (RL Cloud Sandbox Classification and Risk Score Mapping)"
      />
    </ModalWrapper>
  );
};

export default RlcsClassificationMapModal;
